module.exports = __webpack_public_path__ + "static/media/Torii_Tunnel1.a5841c92.jpg";